module.exports = __webpack_public_path__ + "static/media/icon_point-down.1cd75f34.svg";